import { useLocation } from '@reach/router';
import React from 'react';

import GreyLinkIcon from '../../assets/svg/grey-link.inline.svg';
import * as styles from './anchor-link.module.css';

export function AnchorLink({ children, mark }) {
	// hooks
	const location = useLocation();

	const { anchorLinkId } = mark;

	const pageUrl = `${location.origin}${location.pathname}`;

	return (
		<div className={styles.anchorLinkContainer} id={anchorLinkId}>
			<button
				aria-label='Copy page URL'
				className={styles.copyButton}
				onClick={() => {
					navigator.clipboard.writeText(`${pageUrl}#${anchorLinkId}`);
				}}
			>
				<GreyLinkIcon />
			</button>
			<span>{children}</span>
		</div>
	);
}
